
<template>
  <div :class="[formGroupClass, 'form-group']">
    <label class="control-label" v-if="alias">{{ alias }}:</label>
    <div class="input-group input-group-sm">
      <input
        :ref="'input'"
        :type="type"
        :class="['form-control', 'form-control-sm', {' border-right-0' : !getError }, { 'is-invalid': getError }]"
        :value="value"
        :name="name"
        :disabled="disabled"
        @input="onInput"
        @blur="onBlur"
        @change="onChange($event)"
      />
      <div class="input-group-append is-invalid ">
        <span class="input-group-text border-left-0 text-muted" style="cursor:pointer; background-color:white" @click="toggleType()"><i :class="['far', icon]"></i></span>
      </div>
    </div>
    <div class="invalid-feedback invalid-feedback-overwrite" v-if="getError">
      {{ getError }}
    </div>
  </div>
</template>

<script>
export default {

props: {
    value: {},

    formGroupClass: {},

    name: {},
    alias: {},

    disabled: {
      default: false,
    },

    form: {
      default: null,
    },
    
    error: {},
  },

  data : () => ({
    isPassword : true,
  }),

  computed: {
    getError() {
      if (this.form !== null) {
        return this.form.getErrors(this.name);
      }
      return false;
    },

    type() {
      return (this.isPassword) ? 'password' : 'text'
    },

    icon() {
      return (this.isPassword) ? 'fa-eye' : 'fa-eye-slash' 
    }
  },

  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },

    onBlur(event) {
      this.$emit("blur");
      this.validate();
    },

    onChange(event) {
      this.$emit("change", event.target.value);
    },

    validate() {
      if (this.form != undefined) {
        this.form.validate(this.name);
      }
    },

    setFocus() {
      this.$refs.input.focus();
    },

    toggleType() {
      this.isPassword = !this.isPassword
    }
  },
};
</script>

<style>
.invalid-feedback-overwrite {
  font-size: 12px;
}
</style>

